import { fontList } from '../../core/font-list';
import {colorListPairs, colorMap,colorListCharts} from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '900 x 600',
        'value': [900, 600],
        'label': '900 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 900,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 50,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 80,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 80,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'backgroundColor': {
      'default': '#bbb',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconColor': {
      'default': '#FFFFFF',
      'label': 'iconColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconOpacity': {
      'default': 1,
      'label': 'iconOpacity',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconX': {
      'default': 550,
      'label': 'iconX',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconY': {
      'default': 255,
      'label': 'iconY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundX': {
      'default': 510,
      'label': 'logoBackgroundX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundY': {
      'default': 85,
      'label': 'logoBackgroundY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundRadius': {
      'default': 60,
      'label': 'logoBackgroundRadius',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundColor': {
      'default': '#FFFFFF',
      'label': 'logoBackgroundColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBorderColor': {
      'default': '#069',
      'label': 'logoBorderColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBackgroundRadiusWidth': {
      'default': 3,
      'label': 'logoBackgroundRadiusWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoWidth': {
      'default': 60,
      'label': 'logoWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoX': {
      'default': 0,
      'label': 'logoX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoY': {
      'default': 0,
      'label': 'logoY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoColor': {
      'default': '#222222',
      'label': 'logoColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'textWidth': {
      'default': 380,
      'label': 'textWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'textX': {
      'default': 50,
      'label': 'textX',
      'type': 'number',
      'control': 'standard-number',
    },
    'textY': {
      'default': 190,
      'label': 'textY',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1X': {
      'default': 50,
      'label': 'titleTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1Y': {
      'default': 80,
      'label': 'titleTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1': {
      'default': '2,2% mehr Pkw-Neuzulassungen\nim ersten Quartal 2018',
      'label': 'titleTextSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'titleTextSlide1FontSize': {
      'default': 48,
      'label': 'titleTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1LineHeight': {
      'default': 1.4,
      'label': 'titleTextSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1FontColor': {
      'default': '#B10026',
      'label': 'titleTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1X': {
      'default': 50,
      'label': 'textSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1Y': {
      'default': 230,
      'label': 'textSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1': {
      'default': 'Der Trend zu Benzin, Elektro\nund Hybriden hält weiterhin an.',
      'label': 'textSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textSlide1FontSize': {
      'default': 32,
      'label': 'textSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1LineHeight': {
      'default': 1.4,
      'label': 'textSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'textSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1FontWeight': {
      'default': 'bold',
      'label': 'textSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2': {
      'default': 'Marktanteile der letzten 24 Monate',
      'label': 'titleTextSlide2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2X': {
      'default': 20,
      'label': 'titleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2Y': {
      'default': 54,
      'label': 'titleTextSlide2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2FontSize': {
      'default': 32,
      'label': 'titleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'titleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line1': {
      'default': 'Benzin-betrieben Pkw seit Anfang 2018 mehr als 50% Marktanteil',
      'label': 'subtitleTextSlide2Line1',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line2': {
      'default': '',
      'label': 'subtitleTextSlide2Line2',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2X': {
      'default': 20,
      'label': 'subtitleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line1Y': {
      'default': 95,
      'label': 'subtitleTextSlide2Line1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line2Y': {
      'default': 110,
      'label': 'subtitleTextSlide2Line2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontSize': {
      'default': 24,
      'label': 'subtitleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'subtitleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'subtitleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'bannerHeight': {
      'default': 133,
      'label': 'bannerHeight',
      'type': 'string',
      'control': 'standard-number',
    },
    'minY': {
      'default': 0,
      'label': 'minY',
      'type': 'string',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 60,
      'label': 'maxY',
      'type': 'string',
      'control': 'standard-number',
    },
    'steps': {
      'default': 3,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitText': {
      'default': '%',
      'label': 'unitText',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitFontFamily': {
      'default': 'Helvetica',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'unitTextOffsetY',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 60,
      'label': 'labelSpaceY',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'labelSpaceX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#7f7f7f',
      'label': 'labelColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 20,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelFontSize': {
      'default': 24,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      'default': 'Helvetica',
      'label': 'labelFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontAnchor': {
      'default': 'start',
      'label': 'labelFontAnchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'labelOffsetY',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'labelOffsetX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'labelDecimalsY',
      'type': 'number',
      'control': 'standard-number',
    },
    'leftLabelX': {
      'default': '2016',
      'label': 'leftLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2018',
      'label': 'rightLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#979797',
      'label': 'axisStroke',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 1,
      'label': 'axisStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': ['#e6013aff', '#0081d2ff' , '#ccccccff'],
      'label': 'lineStrokes',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'lineStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Miter'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Miter'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Round'
        }
      ],
      'control': 'standard-select',
    },
    'legend': {
      'default': true,
      'label': 'Show legend',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    // 'legendRows': {
    //   'default': 1,
    //   'label': 'Aantal rijen in de legend',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    'legendFontFamily': {
      'default': 'Helvetica',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'legendItemWidth' : {
      'default': 30,
      'label': 'Breede van het legend item',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Is de breede van het ledgend item voor de tekst',
    },
    'legendOffsetY' : {
      'default': 80,
      'label': 'Y offset legenda',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Offset van de legends naar de grafiek erboven',
    },
    'legendSpaceBetweenColumns' : {
      'default': 180,
      'label': 'Breede legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemDistance' : {
      'default': 30,
      'label': 'Afstand tussen de legenda items',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontSize' : {
      'default': 20,
      'label': 'Lettergrotte in de legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'ledgendSpaceBetweenItemAndText': {
      'default': 5,
      'label': 'Afstand tussen item en tekst in legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'fi',
        'value': 'fi',
        'label': 'Suomen kieli'
      },
      'label': 'Taal',
      'type': 'string',
      'values': [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        },
        {
          'key': 'fi',
          'value': 'fi',
          'label': 'Suomen kieli'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'timings': {
    'pauseSlides': {
      'default': 3,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 1,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['Diesel', 'Benzin', 'Übrige'], [56.52097534, 41.18122409, 2.297800576], [57.65162514, 39.87733697, 2.471037895], [56.53969199, 41.37712968, 2.083178335], [56.62726889, 40.16040523, 3.212325876], [55.65424320, 40.90695804, 3.438798767], [55.33817988, 41.35043581, 3.311384311], [56.15707505, 40.72417716, 3.118747793], [60.29537838, 36.65731432, 3.027823241], [53.96933819, 42.45977535, 3.570886460], [53.36810083, 43.16700249, 3.464896685], [51.03448276, 45.06109150, 3.904425740], [50.11092348, 46.34614748, 3.542929042], [49.65459816, 46.70326281, 3.642139024], [49.41734150, 46.71425750, 3.868401004], [50.15325809, 45.64206123, 4.204680682], [49.32458362, 45.79016041, 4.885255967], [46.78948794, 49.30574370, 3.904768355], [46.71080583, 48.88471888, 4.404475287], [45.64930450, 49.91369682, 4.436998680], [50.38789911, 45.18342365, 4.428677245], [43.28269392, 52.13525623, 4.582049846], [42.98652779, 52.79444507, 4.219027133], [39.88759285, 55.18682746, 4.925579688]],
    'columnLimitMin': 1,
    'columnLimitMax': 4,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 1000,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'backgroundColor', 'iconColor', 'iconOpacity', 'iconX', 'iconY', 'titleTextSlide1', 'titleTextSlide1Y', 'textSlide1', 'textSlide1Y'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': [],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-sat-triptych-line-hor-steps/social.params.ts